import { render } from "./Public.vue?vue&type=template&id=1855de1e&scoped=true"
import script from "./Public.vue?vue&type=script&lang=js"
export * from "./Public.vue?vue&type=script&lang=js"

import "./Public.vue?vue&type=style&index=0&id=1855de1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1855de1e"]])

export default __exports__